import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'


/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import PrefixApi from 'api/setting/default-users/prefix.api'

/** UTILS || SLICE */
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */

import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  PREFIX_NAME: ``,
  IS_DUPLICATE_PREFIX_NAME: ``,
  PREFIX_NAME_STRING_BASE: ``,
  PREFIX_NAME_STRING_EMPTY: ``,
  PREFIX_NAME_MAXIMUM_LENGTH: ``,
  PREFIX_NAME_ANY_REQUIRED: ``,

  PREFIX_NAME_EN: ``,
  IS_DUPLICATE_PREFIX_NAME_EN: ``,
  PREFIX_NAME_EN_STRING_BASE: ``,
  PREFIX_NAME_EN_STRING_EMPTY: ``,
  PREFIX_NAME_EN_MAXIMUM_LENGTH: ``,
  PREFIX_NAME_EN_ANY_REQUIRED: ``
}
export default function Prefixes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [prefixs, setPrefixs] = useState([])

  const [prefixId, setPrefixId] = useState(Number)
  const [prefixName, setPrefixName] = useState('')
  const [prefixNameEn, setPrefixNameEn] = useState('')
  const [prefixStatus, setPrefixStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isPopup, setIsPopup] = useState(false)

  const loadData = async () => {
    try {
      const resp = await PrefixApi.findAll({
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setPrefixs(resp.data)
      } else {
        setPrefixs([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const submit = () => {
    if (!prefixName) return setErrorMessage({ ...errorMessage, ...{ PREFIX_NAME: t('PREFIX.MESSAGE.PREFIX_NAME') } })

    dispatch(submitModal())
    setDisabledSubmit(true)

    PrefixApi.create(prefixName, prefixNameEn)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('PREFIX.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({
            ...errorMessage,
            ...{
              [err.message]: t(`PREFIX.MESSAGE.${err.message}`)
            }
          })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({
          ...errorMessage,
          ...{
            [err.message]: t(`PREFIX.MESSAGE.${err.message}`)
          }
        })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (!prefixName) return setErrorMessage({ ...errorMessage, ...{ PREFIX_NAME: t(`PREFIX.MESSAGE.PREFIX_NAME`) } })
    dispatch(submitModal())
    setDisabledSubmit(true)
    PrefixApi.update(prefixId, {
      prefixName,
      prefixNameEn,
      status: prefixStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`PREFIX.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PREFIX.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PREFIX.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setPrefixId(0)
    setPrefixName('')
    setPrefixNameEn('')
    setPrefixStatus('')
    clearErrorMessage()
    setIsPopup(false)
  }

  const onActive = () => {
    if (id) {
      PrefixApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PREFIX.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PREFIX.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      PrefixApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PREFIX.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PREFIX.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { prefixId: pfxId, prefixName: pfxName, prefixNameEn: pfxNameEn, status: pfxStatus } = data
    setPrefixId(pfxId)
    setPrefixName(pfxName)
    setPrefixNameEn(pfxNameEn)
    setPrefixStatus(pfxStatus)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'prefixName', disablePadding: false, label: t('PREFIX.TABLE.CELL.PREFIX_NAME') },
    { id: 'prefixNameEn', disablePadding: false, label: t('PREFIX.TABLE.CELL.PREFIX_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('PREFIX.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('PREFIX.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { prefixId: pfxId, prefixName: pfxName, prefixNameEn: pfxNameEn, updatedBy, updatedAt, status: pfxStatus } = objData
    const statusBtnActive = pfxStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = pfxStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: pfxId,
      id: pfxId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: pfxName },
        { option: 'TEXT', align: 'left', label: pfxNameEn },
        { option: 'STATUS', align: 'center', label: pfxStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.prefixName)
    setNameEn(obj.prefixNameEn)
  }


  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`PREFIX.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`PREFIX.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { prefixName: name, prefixNameEn: nameEn && `(${nameEn})`, status: t(`PREFIX.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('PREFIX.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('PREFIX.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />
              <MainButton
                title={t('PREFIX.BUTTON.ADD')}
                disabled={permissions.isCreate.disabled}
                type='primary'
                variant='contained'
                onClick={() => setIsPopup(true)}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={prefixs.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
        <PageModal
          title={prefixId ? t('PREFIX.TITLE_UPDATE') : t('PREFIX.TITLE_CREATE')}
          isOpen={isPopup}
          onCancel={{ onClick: () => resetForm() }}
          onSubmit={{ onClick: () => prefixId ? submitEdit() : submit(), disabled: disabledSubmit }}
          handleClose={resetForm}
          size={'XS'}
        >
          <Box py={2}>
            {prefixId ? (
              <Box display="flex" justifyContent="space-between" alignItems="center" pb={1}>
                <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
                <SwitchButton
                  onChange={() => setPrefixStatus(prefixStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                  checked={prefixStatus === 'ACTIVE' ? true : false}
                />
              </Box>
            ) : (
              ''
            )}

            <Box display={'flex'} flexDirection={'column'} gap={'24px'}>
              <TextInput
                fullWidth
                onChange={(event) => {
                  setPrefixName(event.target.value)
                  clearErrorMessage()
                }}
                value={prefixName}
                label={t('PREFIX.INPUT.PREFIX_NAME')}
                helperText={
                  errorMessage.PREFIX_NAME || errorMessage.IS_DUPLICATE_PREFIX_NAME || errorMessage.PREFIX_NAME_STRING_BASE || errorMessage.PREFIX_NAME_STRING_EMPTY || errorMessage.PREFIX_NAME_MAXIMUM_LENGTH || errorMessage.PREFIX_NAME_ANY_REQUIRED
                }
                required={true}
              />
              <TextInput
                fullWidth
                onChange={(event) => {
                  setPrefixNameEn(event.target.value)
                  clearErrorMessage()
                }}
                value={prefixNameEn}
                helperText={
                  errorMessage.PREFIX_NAME_EN ||
                  errorMessage.IS_DUPLICATE_PREFIX_NAME_EN ||
                  errorMessage.PREFIX_NAME_EN_STRING_BASE ||
                  errorMessage.PREFIX_NAME_EN_STRING_EMPTY ||
                  errorMessage.PREFIX_NAME_EN_MAXIMUM_LENGTH ||
                  errorMessage.PREFIX_NAME_EN_ANY_REQUIRED
                }
                label={t('PREFIX.INPUT.PREFIX_NAME_EN')}
                required={false}
              />
            </Box>
          </Box>
        </PageModal>
      </Box>
    </Box >
  )
}
